import { Component, Input, OnInit } from '@angular/core';
import { ChartOptions } from '../../../views/tips/charts/charts.component';

@Component({
  selector: 'app-carbon-tabs',
  templateUrl: './carbon-tabs.component.html',
  styleUrls: ['./carbon-tabs.component.scss']
})
export class CarbonTabsComponent implements OnInit {


  @Input() widgets: any[] = [];
  @Input() barChartOptions!: Partial<ChartOptions>;
  @Input() pieChartOptions!: Partial<ChartOptions>;
  @Input() barVerticalChartOptions!: Partial<ChartOptions>;
  @Input() verticalChart: any


  ngOnInit(): void {
    console.log(this.verticalChart)
  }

}
